import React from "react";
import { pageHeadings } from "../helpers/pagesUtil";
import { DashboardView } from "../hooks/useDashboardViews";

interface PageHeadingsProps {
  selectedPage: number;
  dashboardViews?: DashboardView[];
  setSelectedPage: React.Dispatch<React.SetStateAction<number>>;
}

const PageHeadings: React.FC<PageHeadingsProps> = ({
  selectedPage,
  setSelectedPage,
  dashboardViews = [],
}) => {
  // Use API data if available, otherwise fallback to hardcoded pageHeadings
  const pageNames = dashboardViews.length > 0 
  ? dashboardViews.map(dashboard => dashboard.name)
  : pageHeadings;

  const totalPages = pageNames.length;

  const handleNext = () => {
    if (selectedPage < totalPages) {
      setSelectedPage(selectedPage + 1);
    }
  };

  const handlePrevious = () => {
    if (selectedPage > 1) {
      setSelectedPage(selectedPage - 1);
    }
  };

  return (
    <div className="page-headings-v2">
      {/* Default Grid Design for Larger Screens */}
      <div className="horizontal-line">
        {Array.from({length: pageNames.length}, (_, i) => i + 1).map((pageNumber, index) => (
          <div key={pageNumber} className="button-with-text">
            <button
              className={`round-button ${
                selectedPage === pageNumber ? "selected" : ""
              }`}
              onClick={() => setSelectedPage(pageNumber)}
            >
              {(pageNames[index] || "").split(" ").map((line, i) => (
                <span key={i}>{line}</span>
              ))}
            </button>
          </div>
        ))}
      </div>

      {/* Slider Design for Small Devices */}
      <div className="slider">
        <div className="horizontal-line2"></div>
        <button className="arrow-button" onClick={handlePrevious}>
         &#10094; {/* Left Arrow */}
        </button>
        <div className="button-with-text">
          <button className="round-button selected">
            {selectedPage < 10 ? "0" : ""}
            {selectedPage}
          </button>
          <div className="button-text">
            {(pageNames[selectedPage - 1] || pageHeadings[selectedPage - 1] || "")
              .split(" ")
              .map((line, i) => (
                <span key={i}>{line}</span>
              ))}
          </div>
        </div>
        <button className="arrow-button" onClick={handleNext}>
          &#10095; {/* Right Arrow */}
        </button>
      </div>
    </div>
  );
};

export default PageHeadings;

